function _id(id) {
  return document.getElementById(id);
}

const form = _id("phone_number_login_form");
const phoneNumberInput = _id("customer_phone_number");
const phoneNumberFormErrorMessage = _id("phone-number-login-error-message");
const phoneNumberSubmitButton = _id("phone-number-login-submit-button");
const otpForm = _id("otp-form");
const errorText = _id("register-phone-error");
const registrationDetails = _id("phone-registration-details");
const registrationFirstName = _id("phone-registration-first-name");
const registrationLastName = _id("phone-registration-last-name");
const registrationSubmitButton = _id("phone-registration-submit-button");
const registrationBackButton = _id("phone-registration-back-button");
const registrationErrorMessage = _id("phone-registration-error-message");

phoneNumberInput.addEventListener("input", (e) => {
  errorText.style.display = 'none';
  phoneNumberFormErrorMessage.innerHTML = "";

  phoneNumberSubmitButton.disabled = e.target.value.length !== 13;
});

const validation = () => {
  return phoneNumberInput.value.length !== 13;
};

const showOtpForm = () => {
  form.style.display = "none";
  registrationDetails.style.display = "none";
  otpForm.style.display = "block";
};

const showRegistrationDetails = () => {
  form.style.display = "none";
  otpForm.style.display = "none";
  registrationDetails.style.display = "block";
  registrationFirstName.focus();
};

const showPhoneForm = () => {
  registrationDetails.style.display = "none";
  otpForm.style.display = "none";
  form.style.display = "block";
  registrationErrorMessage.textContent = "";
  phoneNumberInput.focus();
};

const getResponseMessage = (data) => {
  if (data && data.data && data.data.message) {
    return data.data.message;
  }

  if (data && data.message) {
    return data.message;
  }

  return "Не удалось отправить SMS. Попробуйте ещё раз.";
};

const customerDoesNotExist = (res, data) => {
  const message = getResponseMessage(data).toLocaleLowerCase("ru");

  return res.status === 404 && message.includes("профиль не найден");
};

const registerCustomerByPhone = async (phone, firstName, lastName) => {
  const body = {
    first_name: firstName,
    last_name: lastName,
    phone,
    email: "",
    birthday: "",
  };

  const res = await fetch(
    `${window.location.origin}/apps/yvesrocher/customer/register`,
    {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
  const data = await res.json();

  if (!res.ok) {
    throw new Error(getResponseMessage(data));
  }

  showOtpForm();
};

const updateRegistrationButton = () => {
  registrationSubmitButton.disabled =
    registrationFirstName.value.trim() === "" ||
    registrationLastName.value.trim() === "";
};

[registrationFirstName, registrationLastName].forEach((input) => {
  input.addEventListener("input", () => {
    registrationErrorMessage.textContent = "";
    updateRegistrationButton();
  });
});

registrationBackButton.addEventListener("click", showPhoneForm);

registrationSubmitButton.addEventListener("click", async () => {
  const firstName = registrationFirstName.value.trim();
  const lastName = registrationLastName.value.trim();

  if (!firstName || !lastName) {
    registrationErrorMessage.textContent = "Укажите имя и фамилию.";
    return;
  }

  registrationSubmitButton.disabled = true;
  registrationErrorMessage.textContent = "";

  try {
    await registerCustomerByPhone(
      phoneNumberInput.value,
      firstName,
      lastName
    );
  } catch (error) {
    registrationErrorMessage.textContent = error.message;
  } finally {
    updateRegistrationButton();
  }
});

phoneNumberSubmitButton.addEventListener("click", (event) => {
  event.preventDefault();
  const hasError = validation();

  if (hasError) {
    errorText.style.display = 'block';
    console.log('error phone');
  } else {
    sendOtpToPhoneNumber();
  }
});

const sendOtpToPhoneNumber = async () => {
  phoneNumberSubmitButton.disabled = true;
  phoneNumberFormErrorMessage.textContent = "";
  const body = {
    phone: phoneNumberInput.value,
  };

  const config = {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await fetch(
      `${window.location.origin}/apps/yvesrocher/customer/login`,
      config
    );
    const data = await res.json();

    if (res.ok) {
      showOtpForm();
      return;
    }

    if (customerDoesNotExist(res, data)) {
      showRegistrationDetails();
      return;
    }

    throw new Error(getResponseMessage(data));
  } catch (error) {
    phoneNumberFormErrorMessage.textContent = error.message;
  } finally {
    phoneNumberSubmitButton.disabled = false;
  }
};
